import { createContext, useContext } from 'react';

import type { TourApi } from './tourTypes';

const noop = () => undefined;

export const INERT_TOUR_API: TourApi = {
  status: 'idle',
  stepIndex: 0,
  phaseIndex: 0,
  source: null,
  reducedMotion: false,
  demoPeriodIndex: 0,
  record: 'unseen',
  start: noop,
  dismiss: noop,
  next: noop,
  back: noop,
  skip: noop,
  exitWith: noop,
  reportTargetClick: noop,
  offerVisible: false,
  chipVisible: false,
  tourBlocked: false,
  isNarrow: false,
  copyHintVisible: false,
};

export const TourContext = createContext<TourApi>(INERT_TOUR_API);

/** Safe anywhere: without a provider it returns an inert api. */
export function useTour(): TourApi {
  return useContext(TourContext);
}
